import React from 'react';
import { Link, useRouteMatch } from "react-router-dom";

import IconMyBeatport from './svg/IconMyBeatport';

import { useSelector } from "react-redux";

// TODO - optimization re-render if only selected

function MyBeatportMenu() {
  const storeRoute = useSelector(state => state.storeRoute)
  const storePopup = useSelector(state => state.storePopup)
  const isConnected = useSelector(state => state.isConnected)
  let match = useRouteMatch({ path: '/my-beatport', exact: true });
  const setHistory = () => {
    if (isConnected) {
      storeRoute.goTo('/my-beatport');
    } else {
      storePopup.myBeatport();
    }
  }

  return (
    <div className={`menu-left-container ${match && `selected`} `} >
      {isConnected ? (
        <Link id={`link-ref-rp`} onClick={setHistory} style={{textDecoration: `none`}} to={isConnected ? '/my-beatport' : '/'}>
          <div id={`ref-my-beatport`} className={`flexRow align top-menu-container ${match && `selected`}`}>
            <IconMyBeatport />
            <span className={`type-medium fz14`}>My Beatport</span>
          </div>
        </Link>
      ) : (
        <div id={`ref-my-beatport`} onClick={setHistory} style={{cursor: 'pointer'}}  className={`flexRow align top-menu-container ${match && `selected`}`}>
          <IconMyBeatport />
          <span className={`type-medium fz14`}>My Beatport</span>
        </div>
      )}
    </div>
  )
}

export default MyBeatportMenu;
